import {createRouter, createWebHistory} from 'vue-router'
import useGtmEvent from "./use/useGtm";
import { ref } from "vue";

const {gtmEventv4} = useGtmEvent();

const panelReassuranceItems = [
  {
    contenu: 'Rapide et sans démarche',
    icone: require('@/assets/img/icones/fusee.svg')
  },
  {
    contenu: 'Suivi personnalisé',
    icone: require('@/assets/img/icones/loupe.svg')
  },
  {
    contenu: 'Tarifs négociés et sans frais caché',
    icone: require('@/assets/img/icones/pouce.svg')
  },
  {
    contenu: 'Aucune coupure d\'énergie',
    icone: require('@/assets/img/icones/infini.svg')
  }
];

const routes = [{
  path: '/', component: () => import("./pages/FormMain.vue"), children: [{
    path: '', name: 'raison-sociale', components: {
      default: () => import('@/components/form/RaisonSocialeField.vue'),
      sidebar: () =>  import('@/components/panel/PanelReassurance.vue')
    },
    props: {
      default: false,
      sidebar: {
        items: panelReassuranceItems
      }
    },
    meta: {
      etape: "votre-identite",
    }
  },
  {
    path: '/votre-entreprise/est-publique',
    name: 'est-commande-publique',
    components: {
      default: () => import('./components/form/CommandePubliqueField.vue'),
      sidebar: () =>  import('@/components/panel/PanelReassurance.vue')
    },
    props: {
      default: false,
      sidebar: {
        items: panelReassuranceItems
      }
    },
    meta: {
      etape: "votre-identite",
    }
  },
  {
    path: '/votre-entreprise/contact',
    name: "entreprise-contact",
    component: () => import('./components/form/ContactEntrepriseField.vue'),
    meta:{
      etape: "votre-identite"
    }
  },
  {
    path: '/votre-entreprise/contact/confirmation',
    name: 'entreprise-contact-confirmation',
    components: {
      default: () => import('@/components/form/ValiderEmailEntreprise.vue'),
      sidebar: () => import('@/components/panel/PanelReassurance.vue')
    },
    props: {
      default: false,
      sidebar: {
        items: panelReassuranceItems
      }
    },
    meta:{
      etape: "votre-identite"
    }
  }, {
    path: '/votre-entreprise/perimetre', name: "entreprise-perimetre", components: {
      default: () => import( "./components/form/PerimetreEntreprise.vue"),
      sidebar: () => import('@/components/panel/PanelReassurance.vue')
    },
    props: {
      default: false,
      aide: false,
      sidebar: {
        items: panelReassuranceItems
      }
    },
    meta: {
      etape: "votre-identite"
    }
  },
  {
    path: '/vos-besoins/energie', name: "energie", components: {
      default: () => import( "./components/form/EnergieField.vue"), aide: () => import("./components/etapes/aide/SecteurAide.vue"),
    }, meta: {
      etape: "vos-besoins"
    }
  }, {
    path: '/vos-besoins/objet-demande', name: "objet-demande", components: {
      default: () => import( "./components/form/RaisonMiseEnConcurrenceField.vue"), aide: () => import("./components/etapes/aide/RaisonMiseEnConcurrenceAide.vue"),
    }, meta: {
      etape: "vos-besoins"
    }
  }, {
    path: '/vos-compteurs/compteurs', name: "compteurs", components: {
      default: () => import( "./components/form/CollectionCompteurs.vue"), aide: () => import("./components/etapes/aide/CompteurAide.vue"),
    }, meta: {
      etape: "vos-compteurs"
    }
  }, {
    path: '/vos-compteurs/accord-grd', name: "accord-grd", components: {
      default: () => import( "./components/form/AccordGrdField.vue"), aide: () => import("./components/etapes/aide/InformationsPersonnelleAide.vue"),
    }, meta: {
      etape: "vos-compteurs"
    }
  }, {
    path: '/vos-compteurs/mise-en-service', name: "mise-en-service", components: {
      default: () => import( "./components/form/MiseEnServiceCompteur.vue"), aide: () => import("./components/etapes/aide/MiseEnServiceAide.vue"),
    }, meta: {
      etape: "vos-compteurs"
    }
  }, {
    path: '/vos-informations/vos-informations', name: "vos-informations", components: {
      default: () => import( "./components/form/InformationsPersonnelles.vue"), aide: () => import("./components/etapes/aide/InformationsPersonnelleAide.vue"),
    }, meta: {
      etape: "vos-informations"
    }
  }, {
    path: '/vos-informations/confidentialite', name: "confidentialite", components: {
      default: () => import( "./components/form/RGPDField.vue"), aide: () => import("./components/etapes/aide/InformationsPersonnelleAide.vue"),
    }, meta: {
      etape: "vos-informations"
    }
  },]
}, {
  path: '/404', component: () => import("./pages/errors/404.vue"), name: 'notFound'
}, {
  path: '/500', component: () => import("./pages/errors/500.vue"), name: 'fatalError'
}, {
  path: '/solution/:id', component: () => import( "./pages/Solution.vue"), name: 'solution'
}, {
  path: '/traitement/partiel/:statusCode?', component: () => import("./pages/errors/ErreurTraitement.vue"), name: 'erreurTraitement'
},{
  path: '/:notFound',
  redirect: (to) => ({
    name: 'raison-sociale',
    query: to.query
  })
}]

const router = createRouter({
  history: createWebHistory(), routes,
});

router.beforeEach((to, from, next) => {
  if (from.name === "solution" && to.path !== "/") next("/");
  if (from.matched.length === 0 && to.path !== '/') next("/");
  next()
});
router.afterEach(() => {
  gtmEventv4({
    event: "changement_ecran_leads"
  });
});

export {router};
